import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Eye, EyeOff, Lock, Phone, LogIn, AlertCircle } from "lucide-react";
import gambarlogin from "../../assets/gambarLogin.png";
import logoOJK from "../../assets/OJK-logo.png";
import logoAFPI from "../../assets/AFPI-logo.png";
import "./LoginUser.scss";
import Swal from "sweetalert2";
import { loginUser } from "../../api";

export default function LoginUser() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await loginUser({ phone, password });

      // Simpan token
      if (rememberMe) {
        localStorage.setItem("userToken", data.token);
        localStorage.setItem("userData", JSON.stringify(data.user));
      } else {
        sessionStorage.setItem("userToken", data.token);
        sessionStorage.setItem("userData", JSON.stringify(data.user));
      }

      navigate("/dashboard");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: err.response?.msg || "Terjadi kesalahan. Coba lagi.",
        confirmButtonColor: "#4f46e5",
      });
      setError(err.response?.msg || "Terjadi kesalahan");
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <motion.div
        className="login-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="login-visual">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <img src={gambarlogin} alt="Login Visual" />
          </motion.div>
          <h2>Selamat Datang</h2>
          <p>Kelola pinjaman Anda dengan mudah dan aman.</p>
        </div>

        <div className="login-form-container">
          <div className="form-header">
            <h3>Masuk ke Akun</h3>
            <p>Silakan masukkan detail login</p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <motion.div
                className="error-message"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
              >
                <AlertCircle size={18} />
                <span>{error}</span>
              </motion.div>
            )}

            <div className="input-group">
              <label>No Telepon</label>
              <div className="input-wrapper">
                <Phone className="icon-left" size={20} />
                <input
                  type="text"
                  value={phone}
                  required
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="08xxxxxxxxxx"
                />
              </div>
            </div>

            <div className="input-group">
              <label>Password</label>
              <div className="input-wrapper">
                <Lock className="icon-left" size={20} />
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  required
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Masukkan password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="toggle-password"
                  aria-label={showPassword ? "Sembunyikan password" : "Perlihatkan password"}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="remember-forgot">
              <label className="remember-me">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Ingat saya
              </label>
              {/* <a href="#" className="forgot-password">Lupa password?</a> */}
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? "Memproses..." : (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  Masuk <LogIn size={18} />
                </span>
              )}
            </button>
          </form>

          <div className="partners-footer">
            <img src={logoOJK} alt="OJK" title="Terdaftar dan Diawasi oleh OJK" />
            <img src={logoAFPI} alt="AFPI" title="Anggota AFPI" />
          </div>
        </div>
      </motion.div>
    </div>
  );
}
